import axios from '../../axiosConfig'
import { tokenConfig } from '../auth'
import {
  FETCH_EX_SUBSERIES_PERFILES,
  FETCH_MAS_SUBSERIES,
  GET_EX_SUBSERIES_PERFILES,
  GET_MAS_SUBSERIES,
  SET_BUSQUEDA_SUBSERIE,
  SET_EX_SUBSERIE_SELECCIONADA,
  UNSET_EX_SUBSERIE_SELECCIONADA,
} from '../types'

// GET EX SUBSERIES PERFILES
export const getExSubSeries =
  (grupo_perfil = '', codigo_serie = '', search = '', paginar = 'N') =>
  (dispatch, getState) => {
    dispatch({
      type: FETCH_EX_SUBSERIES_PERFILES,
    })

    let config = tokenConfig(getState)

    if (grupo_perfil == null || grupo_perfil == 'null') grupo_perfil = ''
    if (codigo_serie == null || codigo_serie == 'null') codigo_serie = ''

    axios
      .get(
        `/exSubSeries/?grupo_perfil=${grupo_perfil}&codigo_serie=${codigo_serie}&search=${search}&paginar=${paginar}`,
        config,
      )
      .then(res => {
        dispatch({
          type: GET_EX_SUBSERIES_PERFILES,
          payload: res.data,
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

// GET MÁS SUBSERIES
export const getMasSubSeries =
  (url, grupo_perfil, codigo_serie, limit = 15) =>
  (dispatch, getState) => {
    dispatch({
      type: FETCH_MAS_SUBSERIES,
    })

    if (url == null || url === '') {
      url = `/exSubSeries/?grupo_perfil=${grupo_perfil}&codigo_serie=${codigo_serie}&search=&paginar=S&limit=${limit}`
    } else {
      if (url.startsWith('http://')) {
        url = url.replace('http://', 'https://')
      }
    }

    axios
      .get(url, tokenConfig(getState))
      .then(res => {
        dispatch({
          type: GET_MAS_SUBSERIES,
          payload: res.data,
        })
      })
      .catch(err => console.log(err))
  }

export const setBusquedaSubSerie = search => (dispatch, getState) => {
  dispatch({
    type: SET_BUSQUEDA_SUBSERIE,
    payload: search,
  })
}

export const setExSubSerieSeleccionada = codigo => (dispatch, getState) => {
  dispatch({
    type: SET_EX_SUBSERIE_SELECCIONADA,
    payload: codigo,
  })
}

export const unsetExSubSerieSeleccionada = () => (dispatch, getState) => {
  dispatch({
    type: UNSET_EX_SUBSERIE_SELECCIONADA,
  })
}
